import React, { Component } from "react";
import { AxiosResponse } from "axios";
import { getRequest } from "../../utils/httpRequest";
import {
  CourseCategoriesResource,
  CourseCategoryResource,
} from "../../stores/CourseCategoriesStore/Types";
import SpiritTeacherQuiz from "../AllCourses/components/SpiritTeacherQuiz";

interface State {
  categories: CourseCategoriesResource;
  loaded: boolean;
  quizOpen: boolean;
}

type CategoryStyle = React.CSSProperties & {
  "--cat-col"?: string;
  "--cat-tint"?: string;
  "--cat-edge"?: string;
};

const categoryDisplay = [
  {
    className: "besci",
    icon: "ln-brain",
    matches: ["behaviour", "behavior", "psychology", "science"],
  },
  {
    className: "lead",
    icon: "ln-community",
    matches: ["lead", "wellbeing", "wellness", "mental"],
  },
  {
    className: "mkt",
    icon: "ln-target",
    matches: ["marketing", "strategy", "sales", "brand"],
  },
  {
    className: "ai",
    icon: "ln-bulb",
    matches: ["ai", "innovation", "artificial"],
  },
];

const displayFor = (category: CourseCategoryResource) => {
  const searchable = `${category.slug} ${category.name}`.toLowerCase();

  return (
    categoryDisplay.find(({ matches }) =>
      matches.some((match) => searchable.includes(match)),
    ) || categoryDisplay[0]
  );
};

const courseCount = (category: CourseCategoryResource) => {
  return category.courses.length;
};

const categoryStyle = (category: CourseCategoryResource): CategoryStyle => {
  const style: CategoryStyle = {};

  if (category.label_text_color) {
    style["--cat-col"] = category.label_text_color;
    style["--cat-edge"] = category.label_text_color;
  }

  if (category.label_tile_color) {
    style["--cat-tint"] = category.label_tile_color;
  }

  return style;
};

const byRank = (
  categoryA: CourseCategoryResource,
  categoryB: CourseCategoryResource,
) => categoryA.rank - categoryB.rank;

class BrowseCourseCategories extends Component<{}, State> {
  state: State = {
    categories: [],
    loaded: false,
    quizOpen: false,
  };

  componentDidMount() {
    getRequest<CourseCategoriesResource, void>("/api/course_categories.json")
      .then((response: AxiosResponse<CourseCategoriesResource>) => {
        this.setState({ categories: response.data, loaded: true });
      })
      .catch(() => {
        this.setState({ loaded: true });
      });
  }

  openQuiz = () => {
    this.setState({ quizOpen: true });
  };

  closeQuiz = () => {
    this.setState({ quizOpen: false });
  };

  renderCategoryChip = (category: CourseCategoryResource) => {
    const display = displayFor(category);

    return (
      <a
        className={`cat-chip ${display.className}`}
        href={`/courses#${category.slug}`}
        key={category.id}
        style={categoryStyle(category)}
      >
        <span className="chip-dot" aria-hidden="true" />
        {category.name}
        <span className="chip-count">{courseCount(category)}</span>
      </a>
    );
  };

  render() {
    const { categories, loaded } = this.state;
    const rankedCategories = [...categories].sort(byRank).slice(0, 4);

    if (loaded && categories.length === 0) return null;

    return (
      <>
        <section
          aria-labelledby="explore-h"
          className="section container browse-categories browse-categories--explore"
          id="exploreNext"
        >
          <div className="explore-card">
            <h2 className="explore-title" id="explore-h">
              Find your next course
            </h2>

            <div className="cat-chips">
              {rankedCategories.map(this.renderCategoryChip)}
              <a className="cat-chip chip-all" href="/courses">
                All 40+ courses <span aria-hidden="true">→</span>
              </a>
            </div>

            <div className="explore-foot">
              <button
                aria-haspopup="dialog"
                className="stars-decide"
                id="quizTriggerNudge"
                type="button"
                onClick={this.openQuiz}
              >
                Procrastinate productively:{" "}
                <span className="sd-em">which 42courses brain is yours?</span>
              </button>
            </div>
          </div>
        </section>

        <SpiritTeacherQuiz
          isOpen={this.state.quizOpen}
          onOpen={this.openQuiz}
          onClose={this.closeQuiz}
        />
      </>
    );
  }
}

export default BrowseCourseCategories;
